import { Injectable, signal } from '@angular/core';
import { PopupOptions } from '../../shared/utils/types';

@Injectable({
  providedIn: 'root'
})
export class Popup {
  popup = signal<PopupOptions | null>(null);

  defaultOptions: PopupOptions | null = {
        message: '',
        type: 'success',
        duration: 2000,
        position: 'bottom',
        icon: 'assets/icons/check-popup.svg'
      };
  private timer?: any;

  show(options: PopupOptions) {
    this.defaultOptions = { ...this.defaultOptions, ...options };
    this.clearTimer();
    this.popup.set(this.defaultOptions);

    // Auto close after duration if specified
    if (options.duration !== 0) {
      this.timer = setTimeout(() => this.close(), options.duration ?? 2000);
    }
  }

  close() {
    this.clearTimer();
    this.popup.set(null);
  }

  private clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}
